import React from "react";
import { DronePriceProps } from "../../../types";

const DronePrice: React.FC<DronePriceProps> = ({ pricePerDay, currency }) => {
  // Normalize casing for comparison, but preserve display value
  const getCurrencySymbol = (curr: string) => {
    if (!curr) return "";
    const normalized = curr.trim().toUpperCase();
    if (normalized === "EUR") return "EUR";
    if (normalized === "RON") return "LEI";
    // Optionally handle USD or others, or display as-is
    return curr;
  };

  return (
    <span className="text-primary font-ubuntu font-medium text-base px-10">
      {pricePerDay}
      {getCurrencySymbol(currency)}{" "}
      <span className="font-normal">hour</span>
    </span>
  );
};

export default DronePrice;
